import React, { useState } from "react"
import Post from "./Post";
import "../../styles/BlogIndex.css";

const BlogIndex = ({ props }) => {
    const data = props;
    const allPosts = data.allMdx.edges;
    const categories = ["Culture", "Science", "Programming", "Recipes", "Ideas", "Thoughts", "Other"];

    const emptySearchBoxText = "";

    const [state, setState] = useState({
        filteredData: [],
        searchBoxText: emptySearchBoxText,
        activeCategories: categories,
    });

    const handleSearchBoxChange = event => {
        const searchBoxText = event.target.value;
        const activeCategories = state.activeCategories;
        const data = props;

        const posts = data.allMdx.edges || [];

        const filteredData = posts.filter(post => {
            const { title, tags, category } = post.node.frontmatter;
            return (
                (title.toLowerCase().includes(searchBoxText.toLowerCase()) ||
                    tags.toLowerCase().includes(searchBoxText.toLowerCase())) &&
                (activeCategories.includes(category))
            )
        });

        const newState = {
            searchBoxText,
            filteredData,
            activeCategories
        };

        setState(newState)
    };

    const handleSearchIconChange = event => {
        console.log(categories)
        const iconCategory = event.target.attributes.category.value;
        const searchBoxText = state.searchBoxText;
        let activeCategories = state.activeCategories;
        const data = props;
        const posts = data.allMdx.edges || [];

        if (categories.length === activeCategories.length) {   // Nothing chosen yet
            activeCategories = [iconCategory]
        } else {   // Something chosen already
            if (activeCategories.includes(iconCategory)) {   // Current already included, remove it
                activeCategories = activeCategories.filter(e => e !== iconCategory)
                if (activeCategories.length === 0) {   // Everything removed, add everything as active
                    activeCategories = categories
                }
            } else {    // Something included already, but not current one so add it
                activeCategories.push(iconCategory)
            }
        }

        const filteredData = posts.filter(post => {
            const { title, tags, category } = post.node.frontmatter;
            return (
                (title.toLowerCase().includes(searchBoxText.toLowerCase()) ||
                tags.toLowerCase().includes(searchBoxText.toLowerCase())) &&
                (activeCategories.includes(category))
            )
        });

        setState({
            searchBoxText,
            filteredData,
            activeCategories,
        })
    };

    const { filteredData, searchBoxText, activeCategories} = state;
    // If filteredPosts are not empty and filters exists, then there are filtered search results
    const hasSearchResults = filteredData && ((searchBoxText !== emptySearchBoxText) || (categories.length !== activeCategories.length));
    const posts = hasSearchResults ? filteredData : allPosts;

    return (
        <>
            <div className="bigSearchBox">
                <div className="iconFiltersBox">
                    {categories.map(category => {
                        return (
                            <div className="category-icon-filter-wrapper-1">
                                <div className="category-icon-filter"
                                     style={{backgroundImage: "url(/images/posts/" + category + ".png)"}}
                                     onClick={handleSearchIconChange}
                                     category={category}
                                />
                            </div>
                        )
                    })}
                </div>
                <div className="searchBox">
                    <input
                        className="searchInput"
                        type="text"
                        aria-label="Search"
                        placeholder="Filter posts by title or tags.."
                        onChange={handleSearchBoxChange}
                    />
                </div>
            </div>
            {posts.map(({ node }) => {
                return (
                    <Post post={node} />
                )
            })}
        </>
    )
}

export default BlogIndex

